import {byeSpinnyBoi, formatPrice, helloSpinnyBoi} from "./common";

(function ($) {

    // init variables
    let body = $('body'),
        elites_modal_button_selector = '.btn-search-modal',
        elites_search_modal = $('.modal#skuSearch'),
        pagination_wrapper = elites_search_modal.find('#sku-pagination'),
        sku_list = $('#skuList'),
        pick_sku_selector = '.pickSKU',
        quote_boltpattern = $('#boltpattern'),
        elites_search_btn = $('.sku-search'),
        elites_brand_wrapper = $('.brand-wrapper'),
        elites_model_wrapper = $('.model-wrapper'),
        elites_diameter_wrapper = $('.diameter-wrapper'),
        elites_width_wrapper = $('.width-wrapper'),
        elites_height_wrapper = $('.height-wrapper'),
        elites_min_ply_wrapper = $('.min_ply-wrapper'),
        elites_max_ply_wrapper = $('.max_ply-wrapper'),
        elites_color_wrapper = $('.color-wrapper'),
        elites_min_offset_wrapper = $('.min_offset-wrapper'),
        elites_max_offset_wrapper = $('.max_offset-wrapper'),
        elites_min_lift_wrapper = $('.min_lift-wrapper'),
        elites_max_lift_wrapper = $('.max_lift-wrapper'),
        elites_boltpattern_wrapper = $('.boltpattern-wrapper'),
        elites_inventory_wrapper = $('.inventory-wrapper');

    // update the search BP input to match the quote/main BP input
    quote_boltpattern.change(function () {
        elites_boltpattern_wrapper.find(`option[value="${$(this).val()}"]`).attr('selected', true);
    });

    // show search modal
    body.on('click', elites_modal_button_selector, function () {
        let item_row = $(this).parents('.item-row'),
            item_type = item_row.data('item-type'),
            item_loop = item_row.data('item-loop'),
            item_partnumber = item_row.find('input.partnumber').val();

        sku_list.html('');
        pagination_wrapper.hide();
        elites_search_modal.find('input').val('');
        elites_search_modal.find('.form-group').hide();
        elites_search_modal.find(`.form-group.${item_type}`).show();
        elites_search_modal.data('search-type', item_type);
        elites_search_modal.data('item-loop', item_loop);
        elites_search_modal.find('#skuSearchLabel span').html(item_type);

        if (item_partnumber) {
            handleElitesSearchFields(item_partnumber);
        }

        elites_search_modal.modal('show');
    });

    // search elites
    elites_search_btn.click(() => handleElitesSearch());


    // pick SKU from results
    body.on('click', pick_sku_selector, function () {
        let item_type = elites_search_modal.data('search-type'),
            item_loop = elites_search_modal.data('item-loop'),
            item_rows = $(`.item-row[data-item-type="${item_type}"]`),
            partnumber = $(this).data('partnumber');

        // find line item, append partnumber and trigger change
        // this shit doesn't work `.item-row[data-item-type="${item_type}"][data-item-loop="${item_loop}"]` so we have to do a filter
        item_rows.each(function (index, row) {
            if ($(row).data('item-loop') === item_loop) {
                $(row).find('input.partnumber').val(partnumber).trigger('change');
            }
        });

        elites_search_modal.modal('hide');
    });

    /**
     * Auto populate serach options for elites lookup if item partnumber is already entered for quicker lookup
     *
     * @param item_partnumber
     */
    function handleElitesSearchFields(item_partnumber) {
        let item_type = elites_search_modal.data('search-type')

        if (item_type === 'wheel') {
            $.ajax({
                type: "post",
                url: api_endpoints['wheel_info'],
                data: {
                    wheelPart: item_partnumber,
                    quantity: 4
                }
            }).done(function (result) {
                elites_brand_wrapper.find('input').val(result.brand);
                elites_model_wrapper.find('input').val(result.model);
                elites_diameter_wrapper.find('input').val(result.diameter);
                elites_width_wrapper.find('input').val(result.width);
                elites_color_wrapper.find('input').val(result.color);
                handleElitesSearch();
            })
        } else if (item_type === 'tire') {
            $.ajax({
                type: "post",
                url: api_endpoints['tire_info'],
                data: {
                    tirePart: item_partnumber,
                    quantity: 4
                }
            }).done(function (result) {
                elites_brand_wrapper.find('input').val(result.brand);
                elites_model_wrapper.find('input').val(result.model);
                elites_diameter_wrapper.find('input').val(result.diameter);
                elites_height_wrapper.find('input').val(result.height);
                elites_width_wrapper.find('input').val(result.width);
                handleElitesSearch();
            })
        } else if (item_type === 'suspension') {
            $.ajax({
                type: "post",
                url: api_endpoints['suspension_info'],
                data: {
                    suspensionPart: item_partnumber,
                    quantity: 1
                }
            }).done(function (result) {
                elites_brand_wrapper.find('input').val(result.brand);
                handleElitesSearch();
            })
        }
    }

    /**
     * Make an API request and populate elites results
     *
     * @param page
     */
    function handleElitesSearch(page = 1) {
        helloSpinnyBoi();
        sku_list.html('');

        let data = {
            type: elites_search_modal.data('search-type'),
            brand: elites_brand_wrapper.find('input').val(),
            model: elites_model_wrapper.find('input').val(),
            diameter: elites_diameter_wrapper.find('input').val(),
            height: elites_height_wrapper.find('input').val(),
            width: elites_width_wrapper.find('input').val(),
            min_offset: elites_min_offset_wrapper.find('input').val(),
            max_offset: elites_max_offset_wrapper.find('input').val(),
            min_ply: elites_min_ply_wrapper.find('select').val(),
            max_ply: elites_max_ply_wrapper.find('select').val(),
            color: elites_color_wrapper.find('input').val(),
            boltpattern: elites_boltpattern_wrapper.find('select').val(),
            inventory: elites_inventory_wrapper.find('input').is(':checked') ? 1 : 0,
            min_lift: elites_min_lift_wrapper.find('input').val(),
            max_lift: elites_max_lift_wrapper.find('input').val(),
            vehicle_year: $('#year').val(),
            vehicle_make: $('#make').val(),
            vehicle_model: $('#model').val(),
            vehicle_drive: $('#drive').val(),
            vehicle_trim: $('#trim').val(),
            page: page
        };

        $.ajax({
            type: 'post',
            url: api_endpoints['elites_search'],
            data: data,
            dataType: 'json'
        }).done(function (response) {

            // populate table
            $.each(response.items.data, function (index, sku) {
                sku_list.append(
                    '<tr>' +
                    '<td class="partnumber">' + sku.partnumber + '</td> ' +
                    '<td class="image-column"><img style="max-width:120px;" src="' + sku.image + '"></td>' +
                    '<td class="description">' + sku.description + '</td>' +
                    '<td class="price">' + formatPrice(sku.price) + '</td> ' +
                    '<td class="quantity">' + sku.inventory + '</td>' +
                    '<td> <button type="button" class="button btn btn-primary pickSKU" data-partnumber="' + sku.partnumber + '"> <i class="fa fa-hand-o-left"></i> </button> </td> ' +
                    '</tr>'
                );
            });

            pagination_wrapper.off('page');
            pagination_wrapper.bootpag({
                page: response.items.current_page,
                total: response.items.last_page,
                maxVisible: 10,
                prev: '‹',
                next: '›'
            }).on("page", function (event, num) {
                handleElitesSearch(num);
            });

            pagination_wrapper.show();

            if (response.items.total === 0) {
                sku_list.html('<tr><td colspan="6">No results found.</td></tr>');
                pagination_wrapper.hide();
            }

        }).fail(function (error) {
            let message = 'An error has occurred.';
            if (error.hasOwnProperty('message')) {
                message = error.message;
            }
            sku_list.html(`<tr><td colspan="6">${message}</td></tr>`);
            pagination_wrapper.hide();
        }).always(function () {
            byeSpinnyBoi();
        });
    }
})(jQuery);
